(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-origines"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    if (typeof HTMLDialogElement === 'undefined') return;
    root.classList.add('orig-enhanced');
    const openGalleries = new Map();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    root.querySelectorAll('.orig-dialog').forEach(dialog => {
      const photo = dialog.querySelector('.orig-active-photo');
      const stage = dialog.querySelector('.orig-gallery-main');
      const strip = dialog.querySelector('.orig-thumbnails');
      const buttons = Array.from(dialog.querySelectorAll('[data-photo-src]'));
      const position = dialog.querySelector('[data-photo-position]');
      let active = 0;
      let pointerStart = null;
      let opener = null;
      let savedPadding = '';
      function selectPhoto(index, animate = true) {
        if (!photo || !buttons.length) return;
        active = (index + buttons.length) % buttons.length;
        const selected = buttons[active];
        photo.loading = 'eager';
        photo.sizes = '(min-width: 1200px) 587px, (min-width: 900px) 52vw, 100vw';
        photo.srcset = selected.dataset.photoSrcset;
        photo.src = selected.dataset.photoSrc;
        photo.alt = selected.dataset.photoAlt;
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === selected)));
        if (position) position.textContent = position.dataset.positionTemplate.replace('__CURRENT__', String(active + 1));
        const stripBox = strip.getBoundingClientRect();
        const buttonBox = selected.getBoundingClientRect();
        const left = strip.scrollLeft + buttonBox.left - stripBox.left - (strip.clientWidth - buttonBox.width) / 2;
        strip.scrollTo({left: Math.max(0, left), behavior: animate && !reducedMotion.matches ? 'smooth' : 'instant'});
      }
      openGalleries.set(dialog.id, link => {
        opener = link;
        savedPadding = document.body.style.paddingRight;
        const scrollbar = window.innerWidth - document.documentElement.clientWidth;
        if (scrollbar > 0) document.body.style.paddingRight = `${parseFloat(getComputedStyle(document.body).paddingRight) + scrollbar}px`;
        document.documentElement.classList.add('orig-dialog-open');
        document.body.classList.add('orig-dialog-open');
        dialog.showModal();
        dialog.querySelector('.orig-dialog-scroll').scrollTop = 0;
        selectPhoto(0, false);
      });
      dialog.querySelector('[data-close-gallery]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('orig-dialog-open');
        document.body.classList.remove('orig-dialog-open');
        document.body.style.paddingRight = savedPadding;
        pointerStart = null;
        if (opener) opener.focus({preventScroll: true});
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      });
      buttons.forEach((button, index) => button.addEventListener('click', () => selectPhoto(index)));
      dialog.querySelector('[data-photo-prev]')?.addEventListener('click', () => selectPhoto(active - 1));
      dialog.querySelector('[data-photo-next]')?.addEventListener('click', () => selectPhoto(active + 1));
      dialog.addEventListener('keydown', event => {
        if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey || /INPUT|SELECT|TEXTAREA/.test(event.target.tagName)) return;
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        selectPhoto(active + (event.key === 'ArrowRight' ? 1 : -1));
      });
      stage.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'touch' || !event.isPrimary) return;
        pointerStart = {x: event.clientX, y: event.clientY};
      });
      stage.addEventListener('pointerup', event => {
        if (!pointerStart) return;
        const dx = event.clientX - pointerStart.x;
        const dy = event.clientY - pointerStart.y;
        pointerStart = null;
        if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.3) selectPhoto(active + (dx < 0 ? 1 : -1));
      });
      stage.addEventListener('pointercancel', () => { pointerStart = null; });
    });
    root.querySelectorAll('[data-open-gallery]').forEach(link => {
      link.addEventListener('click', event => {
        const openGallery = openGalleries.get(link.dataset.openGallery);
        if (!openGallery) return;
        event.preventDefault();
        openGallery(link);
      });
    });
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('orig-visible'); observer.unobserve(entry.target); }
      }), {threshold:0.06});
      root.querySelectorAll('[data-reveal]').forEach(item => { item.classList.add('orig-await'); observer.observe(item); });
    }
  }
  document.querySelectorAll('[data-origines]').forEach(init);
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('[data-origines]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
function setupStudioGalleries(root){
root.querySelectorAll('[data-product-gallery]').forEach(gallery=>{
if(gallery.dataset.ready)return;
gallery.dataset.ready='true';
const track=gallery.querySelector('.studio-gallery');
const links=[...gallery.querySelectorAll('[data-gallery-link]')];
const frames=[...track.children];
const mark=index=>links.forEach((link,i)=>link.setAttribute('aria-current',String(i===index)));
links.forEach((link,i)=>link.addEventListener('click',event=>{event.preventDefault();track.scrollTo({left:frames[i].offsetLeft-frames[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});mark(i)}));
track.addEventListener('scroll',()=>mark(Math.round(track.scrollLeft/track.clientWidth)),{passive:true});
mark(0);
});
}
setupStudioGalleries(document);
document.addEventListener('shopify:section:load',event=>setupStudioGalleries(event.target));

  } catch(e) { console.error(e); }
})();
})();
